export default __webpack_public_path__ + "static/media/adolescent.5cbeaccb.png";